//LIVE server
export const API_BASE_URL = window.location.origin+"/MI_Curation";
export const APPLICATION_NAME = "mi-curation";

//TEST server
// export const API_BASE_URL = window.location.origin+"/MI_Curation_Test";
// export const API_BASE_URL = "http://172.233.136.234:7170/MI_Curation_Test";
// export const APPLICATION_NAME = "mi-curation-test";

//local
// export const API_BASE_URL = "http://localhost:7170/MI_Curation_Test";

// test

